export default "__VITE_ASSET__138157a5__"